import { motion } from "framer-motion";
import { FileText, Shield, FlaskConical, Handshake, Award, Building2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const metricMeta = [
  { key: "patents",  value: "2",    icon: Award,        color: "#EE1D25" },
  { key: "pubs",     value: "3",    icon: FileText,     color: "#0044FF" },
  { key: "part",     value: "6",    icon: Handshake,    color: "#10B981" },
  { key: "models",   value: "3+",   icon: FlaskConical, color: "#F59E0B" },
  { key: "grants",   value: "\u20ac1M+", icon: Shield,  color: "#EE1D25" },
  { key: "bsl4",     value: "1",    icon: Building2,    color: "#0044FF" },
];

export default function MetricsTraction() {
  const { t } = useLanguage();
  return (
    <section id="metrics" data-testid="metrics-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="mb-16 text-center">
          <p className="text-[11px] uppercase tracking-[0.2em] text-[#6B7280] font-mono font-medium mb-4">{t("metrics.label")}</p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-[#111827] tracking-tight">{t("metrics.heading")}</h2>
          <p className="text-base text-[#4B5563] mt-4 max-w-xl mx-auto leading-relaxed">
            {t("metrics.sub")}
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {metricMeta.map((m, i) => (
            <motion.div
              key={m.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.07 }}
              data-testid={`metric-card-${i}`}
              className="p-6 md:p-8 border border-[#E5E7EB] hover:border-[#EE1D25]/20 transition-colors duration-300 group"
            >
              <m.icon size={20} style={{ color: m.color }} className="mb-4 group-hover:scale-110 transition-transform duration-300" />
              <p className="font-heading text-3xl md:text-4xl font-black tracking-tight" style={{ color: m.color }}>{m.value}</p>
              <p className="font-heading text-sm font-semibold text-[#111827] mt-2">{t(`metrics.cards.${m.key}L`)}</p>
              <p className="text-xs text-[#6B7280] mt-1 leading-relaxed">{t(`metrics.cards.${m.key}S`)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
